import BinderAutocomplete from "./shared/binder/binder-autocomplete";
import Bookmark from "../components/shared/bookmark/bookmark";
import Category from "../components/shared/category/category";
import ClickEvent from "../components/shared/trackers/click-event";
import CvUploader from "../components/shared/cv-uploader/cv-uploader"
import EmailSuggest from "../components/shared/email/emailSuggest";
import EngineSticky from "./shared/menu/moteur-sticky";
import ForTrigger from "../components/shared/analytics/for-trigger";
import Grid from "../components/shared/grid/grid";
import GridSheet from "../components/shared/grid/grid-sheet"
import Houdini from "../components/shared/houdini/houdini";
import LoadUrl from "./shared/load-url/load-url";
import Menu from "../components/shared/menu/menu";
import Notification from "../components/shared/notification/notification";
import Reload from "../components/shared/search/reload";
import Selector from "../components/shared/multiselect/select";
import SimplePassword from "./shared/inputs/password/simple-password";
import SimpleProgress from "../components/shared/simple-progress/simple-progress";
import SuggestInput from "../components/shared/inputs/autocomplete/autocomplete";
import TabLayout from "../components/shared/tablayout/tablayout";
import TabLayoutParent from "../components/shared/tablayout/tablayout-parent";
import TrackEvent from "../components/shared/trackers/track-event";
import TrackOffer from "../components/shared/analytics/track-offer";
import ValidatedForm from "../components/shared/form/validated-form/validated-form";
import ValidatedInput from "../components/shared/form/validated-input/validated-input";
import ValidatedCheckBoxGroup from "./shared/inputs/group/checkbox/validated-checkbox";
import ValidatedRadioGroup from "./shared/inputs/group/radio/validated-radio";

export default {
    "autocomplete": SuggestInput,
    "binder-autocomplete": BinderAutocomplete,
    "bookmark": Bookmark,
    "category": Category,
    "checkbox-group": ValidatedCheckBoxGroup, 
    "click": ClickEvent,
    "engine-sticky": EngineSticky,
    "email-suggest": EmailSuggest,
    "for": ForTrigger,
    "grid-two": Grid,
    "houdini": Houdini,
    'load-url': LoadUrl,
    "notification": Notification,
    "menu": Menu,
    "radio-group": ValidatedRadioGroup,
    "reload": Reload,
    "rjupload": CvUploader,
    "select!DO_NOT_COPY_THIS!select:not(.selectraw):not(.tw-selectraw)": Selector,
    "sheet": GridSheet,
    "simple-progress": SimpleProgress,
    "simple-password": SimplePassword,
    "tab": TabLayout,
    "tabs": TabLayoutParent,
    "track": TrackEvent,
    "track-offer": TrackOffer,
    "val": ValidatedInput,
    "valid-when": ValidatedForm
}
